import qs from "qs";

// Action Types
export const LIST = "bipp/users/LIST";
export const LIST_SUCCESS = "bipp/users/LIST_SUCCESS";
export const LIST_FAIL = "bipp/users/LIST_FAIL";

export const DETAILS = "bipp/users/DETAILS";
export const DETAILS_SUCCESS = "bipp/users/DETAILS_SUCCESS";
export const DETAILS_FAIL = "bipp/users/DETAILS_FAIL";

export const SAVE = "bipp/users/SAVE";
export const SAVE_SUCCESS = "bipp/users/SAVE_SUCCESS";
export const SAVE_FAIL = "bipp/users/SAVE_FAIL";

export const DELETE = "bipp/users/DELETE";
export const DELETE_SUCCESS = "bipp/users/DELETE_SUCCESS";
export const DELETE_FAIL = "bipp/users/DELETE_FAIL";

// Reducer
const initialState = {
  data: null,
  details: null,
  loading: false,
  module: "usuarios",
  total: 0
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LIST:
      return { ...state, loading: true };
    case LIST_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    case LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case DETAILS:
      return { ...state, loading: true };
    case DETAILS_SUCCESS:
      return {
        ...state,
        details: action.payload.data,
        loading: false
      };
    case DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case SAVE:
      return { ...state, loading: true };
    case SAVE_SUCCESS:
    case SAVE_FAIL:
      return { ...state, loading: false };

    case DELETE:
      return { ...state, loading: true };
    case DELETE_SUCCESS:
    case DELETE_FAIL:
      return { ...state, loading: false };

    default:
      return state;
  }
}

// Action Creators
export function get(params) {
  return {
    type: LIST,
    payload: {
      request: {
        url: `/users?${qs.stringify(params)}`
      }
    }
  };
}

export function getDetails(id) {
  return {
    type: DETAILS,
    payload: {
      request: {
        url: `/users/${id}`
      }
    }
  };
}

export function add(data) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/users`,
        method: "post",
        data: data
      }
    }
  };
}

export function edit(data, id) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/users/${id}`,
        method: "put",
        data: data
      }
    }
  };
}

export function editPassword(data, id) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/users/${id}/change-password`,
        method: "put",
        data: data
      }
    }
  };
}

export function remove(id) {
  return {
    type: DELETE,
    payload: {
      request: {
        url: `/users/${id}`,
        method: "delete"
      }
    }
  };
}
